const startOfDay = (date) => {
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(date ?? ''));

    return parts ? new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3])).getTime() : null;
};

const getPacingRatio = (delivered, booked, starttime, stoptime) => {
    const start = startOfDay(starttime);
    const lastServedDay = startOfDay(stoptime);

    if (start === null || lastServedDay === null) {
        return null;
    }

    const endOfLastServedDay = lastServedDay + 24 * 60 * 60 * 1000;
    const totalDuration = endOfLastServedDay - start;

    if (totalDuration <= 0) {
        return null;
    }

    const elapsed = Math.min(Math.max(Date.now() - start, 0), totalDuration);
    const expectedDelivery = booked * (elapsed / totalDuration);

    return expectedDelivery > 0 ? (delivered / expectedDelivery) * 100 : null;
};

export { getPacingRatio };
